module.exports = __webpack_public_path__ + "static/media/Sagar Kapasi.4e731242.webp";